import { Stack, Group, Text, Box, Divider } from "@mantine/core";
import type { TransitInfo } from "@/api/types";
import { TransitLegRow } from "./TransitLegRow";
import { getTransportConfig } from "./transportConfig";

interface TransitDetailsProps {
  transitInfo: TransitInfo;
  officeAddress?: string;
}

export function TransitDetails({ transitInfo, officeAddress }: TransitDetailsProps) {
  const totalDuration = transitInfo.duration_minutes;

  return (
    <Stack gap="md">
      <Group gap="xs">
        <Text size="sm" fw={500} c="dimmed">
          {transitInfo.duration_minutes} min total
        </Text>
        <Text c="dimmed">•</Text>
        <Text size="sm" c="dimmed">
          {transitInfo.num_changes} {transitInfo.num_changes === 1 ? "change" : "changes"}
        </Text>
      </Group>

      {transitInfo.legs.length > 0 && (
        <Group
          gap={0}
          style={{ height: 8, borderRadius: 999, overflow: "hidden", backgroundColor: "#0f3460" }}
        >
          {transitInfo.legs.map((leg, index) => {
            const config = getTransportConfig(leg.type);
            const widthPercent =
              totalDuration > 0 ? (leg.duration_minutes / totalDuration) * 100 : 0;

            return (
              <Box
                key={index}
                style={{
                  width: `${Math.max(widthPercent, 2)}%`,
                  height: "100%",
                  backgroundColor: config.color,
                  opacity: leg.type === "WALK" ? 0.5 : 1,
                }}
                title={`${leg.type === "WALK" ? "Walk" : leg.line_name || config.label}: ${leg.duration_minutes} min`}
              />
            );
          })}
        </Group>
      )}

      <Box mt="sm">
        {transitInfo.legs.map((leg, index) => (
          <TransitLegRow key={index} leg={leg} isLast={index === transitInfo.legs.length - 1} />
        ))}
      </Box>

      {officeAddress && (
        <>
          <Divider color="#0f3460" />
          <Text size="sm" c="dimmed">
            To: {officeAddress}
          </Text>
        </>
      )}
    </Stack>
  );
}
